import {Directive,TemplateRef } from "@angular/core";

@Directive({
    selector: '[rxCellTemplate]'
})
export class RxCellTemplateDirective {
    templateRef: TemplateRef<any>;

    constructor(templateRef: TemplateRef<any>) {
        this.templateRef = templateRef;
    };
}


// WEBPACK FOOTER //
// ./node_modules/@rx/table/rx-cell-template.directive.ts